import { render, staticRenderFns } from "./MyPathCard.vue?vue&type=template&id=5937796e&scoped=true&"
import script from "./MyPathCard.vue?vue&type=script&lang=js&"
export * from "./MyPathCard.vue?vue&type=script&lang=js&"
import style0 from "./MyPathCard.vue?vue&type=style&index=0&id=5937796e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5937796e",
  null
  
)

export default component.exports